import { BusinessHour } from "../types";

export const PHONE_NUMBER = "+46104248924";
export const PHONE_DISPLAY = "010 - 424 89 24";
export const EMAIL = "kundtjanst@samblapension.se";

export const BUSINESS_HOURS: BusinessHour[] = [
  { day: "Mån", hours: "09-19" },
  { day: "Tis - Tor", hours: "09-18" },
  { day: "Fre", hours: "09-17" },
  { day: "Lör - Sön", hours: "12-16" },
];
